const getIdNamesByCountries={
  AUT:"CONCAT",
  BEL:"Belgian National Number (Numéro de registre national – Rijksregisternummer)",
  BGR:"Bulgarian Personal Number",
  CYP:"National Passport Number",
  CZE:"National identification number (Rodné cislo)",
  DEU:"CONCAT",
  DNK:"Personal Identity Code (alphanumerical – DDMMYYXXXX)",
  EST:"Estonian Personal Identification Code(Isikukood)",
  ESP:"Tax identification number (Código de identifcación fiscal)",
  FIN:"Personal identity code",
  FRA:"CONCAT",
  GBR:"UK National Insurance number",
  GRC:"10 DSS digit investor share",
  HRV:"Personal Identification Number (OIB – Osobni identifikacijski broj)",
  HUN:"CONCAT",
  IRL:"CONCAT",
  ISL:"Icelandic National Identity Code (Kennitala)",
  ITA:"Fiscal code (Codice fiscale)",
  LIE:"National Passport Number",
  LTU:"Personal code (Asmens kodas)",
  LUX:"CONCAT",
  LVA:"Personal code (Personas kods)",
  MLT:"National Identification Number",
  NLD:"National Passport Number",
  NOR:"Foedselsnummer",
  POL:"National Identification Number(PESEL)",
  PRT:"Tax number Número de Identificação (Fiscal)",
  ROU:"National Identification Number (Cod Numeric Personal)",
  SWE:"Personal identity number",
  SVN:"Personal Identification Number (EMŠO: Enotna Matična Številka Občana)",
  SVK:"Personal number (Rodné číslo)",
  AllOtherCountries:"Passport Number",
}

module.exports = getIdNamesByCountries;


// WEBPACK FOOTER //
// ./src/lang/getIdNamesByCountries.js